// Single source of truth for the frontend's app version.
// Bump this in lock-step with /app/backend/app_version.py on every meaningful change.
// Displayed as a small badge in the dashboard header; also compared against the
// backend's /api/version endpoint to prompt a refresh when a new build is deployed.
export const APP_VERSION = "1.0.6";
